import { PatientGuarantorAddress } from "pwapi";

export const checkGuarantorAddress = (
  address?: Partial<PatientGuarantorAddress>
) => {
  return address &&
    Object.keys(address).filter(
      (key) => address[key as keyof PatientGuarantorAddress]
    ).length > 0
    ? address
    : undefined;
};
